import BarChart from './BarChart.jsx';

function EmployedPopulation({ data }) {
  const options = {
    xaxis: {
      categories: [
        'Водоснабжение; канализационная система, контроль над сбором и распределением отходов',
        'Горнодобывающая промышленность и разработка карьеров',
        'Государственное управление и оборона; обязательное социальное обеспечение',
        'Деятельность в области административного и вспомогательного обслуживания',
        'Деятельность домашних хозяйств, нанимающих домашнюю прислугу и производящих товары и услуги для собственного потребления',
        'Деятельность экстерриториальных организаций и органов',
        'Здравоохранение и социальное обслуживание населения',
        'Информация и связь',
        'Искусство, развлечения и отдых',
        'Обрабатывающая промышленность',
        'Образование',
        'Операции с недвижимым имуществом',
        'Оптовая и розничная торговля; ремонт автомобилей и мотоциклов',
        'Предоставление прочих видов услуг',
        'Услуги по проживанию и питанию',
        'Промышленность',
        'Профессиональная, научная и техническая деятельность',
        'Сельское, лесное и рыбное хозяйство',
        'Строительство',
        'Транспорт и складирование',
        'Финансовая и страховая деятельность',
        'Электроснабжение, подача газа, пара и воздушное кондиционирование',
      ],
    },
  };

  const series = Object.keys(data).map((item) => {
    return {
      name: `Человек за ${item} квартал`,
      data: data[item],
    };
  });

  return (
    <BarChart
      series={series}
      options={options}
      title="Численность трудоустроенного населения по видам экономической деятельности, человек, %"
    />
  );
}

export default EmployedPopulation;
